/**
 * Represents the possible portals that we may be using.
 * @enum
 */
export const PORTALS = {
  SHAPA: "SHAPA",
  CLEARSTEP: "CLEARSTEP",
  SHAPA_HEALTH: "SHAPA_HEALTH"
};

/**
 * Represents the possible purchase flows.
 * The purchase flow is more specific than the portal. This enum tells us exactly what purchase flow we are displaying.
 * @enum
 */
export const PURCHASE_FLOWS = {
  SHAPA_END_USER: "SHAPA_END_USER",
  SHAPA_HEALTH_END_USER: "SHAPA_HEALTH_END_USER",
  SHAPA_HEALTH_CLINICIAN: "SHAPA_HEALTH_CLINICIAN",
  CLEARSTEP_END_USER: "CLEARSTEP_END_USER",
  CLEARSTEP_CLINICIAN: "CLEARSTEP_CLINICIAN",
  CLEARSTEP_PARENT: "CLEARSTEP_PARENT",
  SHAPA_BP_ADDON: "SHAPA_BP_ADDON",
  CLEARSTEP_BP_ADDON: "CLEARSTEP_BP_ADDON",
};

/**
 * Represents the possible product types.
 * @enum
 */
export const PRODUCT_CATEGORIES = {
  SCALE: "SCALE",
  MEMBERSHIP: "MEMBERSHIP",
  ADMIN_ACCESS: "ADMIN_ACCESS"
};

/**
 * The device type is similar to the PRODUCT_CATEGORIES enum, but is finer grain. It specifies the type of the physical device.
 * @enum
 */
export const DEVICE_TYPES = {
  SCALE: "SCALE",
  BP_DEVICE: "BP_DEVICE",
  SCALE_BP_BUNDLE: "SCALE_BP_BUNDLE",
};

/**
 * Represents the possible product names.
 * @enum
 */
export const PLAN_NAMES = {
  MONTHLY_THREE_MONTHS_INITIAL: "monthly_3_months_initial",
  MONTHLY: "monthly",
  YEARLY: "yearly",
  LIFETIME: "lifetime",
  THREE_YEAR: "3-year"
};

export const SIGNUP_USER_TYPES = {
  DEFAULT: "DEFAULT",
  PARENT: "PARENT",
  CLINICIAN: "CLINICIAN"
};